<template>
    <div class="container-fluid mb-2 mb-md-3">
        <div class="row">
            <div class="col-12">
                <!-- Les avantages de combiner ces offres Orange -->
                <h3 class="h2" v-html="advantagesTitle" />
            </div>
            <div
                v-for="(advantage, advantageIndex) in advantagesList"
                :key="'advantage_'
                    + (advantage.icon ? advantage.icon : '')
                    + '_'
                    + advantageIndex
                "
                class="col-12 col-lg-4"
            >
                <div class="alert-container h-100 px-0 mb-0">
                    <p class="alert">
                        <span class="alert-icon" :class="[advantage.icon]" aria-hidden="true" />
                        <span v-html="advantage.title" />
                    </p>
                    <div class="alert-content">
                        <p class="alert-text" v-html="advantage.text" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InternetAndMobileAdvantages",
    components: {},
    props: {
        advantagesTitle: {
            type: String,
            required: true
        },
        advantagesList: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
</style>
